export interface CaseItem {
  caseRef: string;
  request: string;
  status: string;
  errorDetails: string[];
}
export interface ISyncReport {
  id?: string;
  batchGroupId?: string;
  createDate: Date;
  totalCases: number;
  updateTime: Date;
  userId: number;
  totalCasesFailed: number;
  totalCasesInProcess: number;
  totalCasesSuccessful: number;
  cases: CaseItem[];
}

export class SyncReport implements ISyncReport {
  constructor(
    public id?: string,
    public batchGroupId?: string,
    public createDate: Date = new Date(),
    public totalCases: number = 0,
    public updateTime: Date = new Date(),
    public userId: number = 0,
    public totalCasesFailed: number = 0,
    public totalCasesInProcess: number = 0,
    public totalCasesSuccessful: number = 0,
    public cases: CaseItem[] = []
  ) {}
}
